import { render, staticRenderFns } from "./DrawingHighlightViewer.vue?vue&type=template&id=6b68aafc&scoped=true"
import script from "./DrawingHighlightViewer.vue?vue&type=script&lang=js"
export * from "./DrawingHighlightViewer.vue?vue&type=script&lang=js"
import style0 from "./DrawingHighlightViewer.vue?vue&type=style&index=0&id=6b68aafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68aafc",
  null
  
)

export default component.exports